import {BaseSyntheticEvent, FC, useEffect, useState} from 'react'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {Button} from '../../../../components/Button/Button'
import Swal from 'sweetalert2'
import {GET, POST, PUT} from '../../../../services/api'
import {Input} from '../../../../components/Input/Input'
import {Loading} from '../../../../components/Loading/Loading'
import {useNavigate} from 'react-router-dom'
import moment from 'moment-timezone'
import {i18n} from '../../../../translate/i18n'
import uuid from 'react-uuid'
import {BreadCrumbs} from '../../../../components/BreadCrumbs/breadCrumbrs'
import {ProductFilter} from '../../../../components/CatalogFilterProducts/FilterModal'
import ProductSearchCard from '../../../../components/CatalogosTable/CatalogTableAdd'
import CatalogProductsTable from '../../../../components/CatalogosTable/CatalogTableItens'
import './catalogs.css'

type TypeListProduct = {
  id: string
  name: string
  price: string
  image: string
  sellerId: string
  allowDiscount: boolean
  sellerCatalog: boolean
  selected: boolean
}

type OrderType = {
  field: string
  type: 'ASC' | 'DESC'
}

type MetaType = {
  hasNextPage: boolean
  hasPreviousPage: boolean
  itemCount: number
  page: number
  pageCount: number
  take: number
}

type FilterOption = {
  label: string
  value: string | number
}

type FilterState = {
  categories: (string | number)[]
  status: string
  groups: (string | number)[]
}

type ProductFilterRequestDTO = {
  name?: string
  categories?: (string | number)[]
  groups?: (string | number)[]
  status?: boolean
  isInventoryGreaterThan?: number
  isInventoryLessThan?: number
}

const CriarCatalogosContent: FC = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [loadingComp, setLoadingComp] = useState(false)
  const [name, setName] = useState('')
  const [order, setOrder] = useState('0')

  const [searchproduct, setSearchProduct] = useState('')
  const [listsearchproducts, setListSearchProducts] = useState<TypeListProduct[]>([])
  const [listProducts, setListProducts] = useState<TypeListProduct[]>([])

  const [startDate, setStartDate] = useState('')
  const [startTimeDate, setStartTimeDate] = useState('')

  const [finalDate, setFinalDate] = useState('')
  const [finalTimeDate, setFinalTimeDate] = useState('')

  const [image, setImage] = useState<File | null>(null)

  /*Novos Campos */
  const [linkCatalog, setLinkCatalog] = useState<string>('')
  const [sellerId, setSellerId] = useState<number>(0)
  const [isExclusive, setIsExclusive] = useState<boolean>(false)
  const [sellerCatalog, setSellerCatalog] = useState<boolean>(false)
  const [sellers, setSeller] = useState<any[]>([])
  const [meta, setMeta] = useState<MetaType | undefined>(undefined)

  // Novos estados para os filtros
  const [showFilters, setShowFilters] = useState(false)
  const [categories, setCategories] = useState<FilterOption[]>([])
  const [groups, setGroups] = useState<FilterOption[]>([])
  const [activeFilters, setActiveFilters] = useState<FilterState>({
    categories: [],
    status: '',
    groups: [],
  })

  const [listProductsSelected, setListProductsSelected] = useState<number>(0)
  const [listProductsCatalogSelected, setListProductsCatalogSelected] = useState<number>(0)

  const loadCategories = async () => {
    try {
      const response = await POST('/classification/filter', {status: true})
      if (response.success) {
        setCategories(
          response.data.map((cat: any) => ({
            label: cat.name,
            value: cat.id,
          }))
        )
      }
    } catch (error) {
      console.error('Erro ao carregar categorias:', error)
    }
  }

  const loadGroups = async () => {
    try {
      const response = await GET('/customer_groups')
      if (response.success) {
        setGroups(
          response.data.map((group: any) => ({
            label: group.name,
            value: group.id,
          }))
        )
      }
    } catch (error) {
      console.error('Erro ao carregar grupos:', error)
    }
  }

  const handleApplyFilters = (filters: FilterState) => {
    setActiveFilters(filters)
    searchProductWithFilters(filters)
  }

  const handleClearFilters = () => {
    setActiveFilters({
      categories: [],
      status: '',
      groups: [],
    })
    // Limpar filtros e refazer a pesquisa
    if (searchproduct) {
      searchProduct()
    }
  }

  const transformFiltersToDTO = (
    filters: FilterState,
    productName: string
  ): ProductFilterRequestDTO => {
    const dto: ProductFilterRequestDTO = {
      name: productName,
      categories: filters.categories.length > 0 ? filters.categories : undefined,
      groups: filters.groups.length > 0 ? filters.groups : undefined,
    }

    // Handle status mapping with switch case
    switch (filters.status) {
      case 'active':
        dto.status = true
        break
      case 'inactive':
        dto.status = false
        break
      case 'in_stock':
        dto.status = true // Assuming active products
        dto.isInventoryGreaterThan = 0
        break
      case 'out_of_stock':
        dto.status = true // Assuming active products
        dto.isInventoryLessThan = 1
        break
      default:
        // If no status filter, don't include status in DTO
        break
    }

    return dto
  }

  const searchProductWithFilters = async (filters: FilterState) => {
    try {
      setLoadingComp(true)
      const filterDTO = transformFiltersToDTO(filters, searchproduct)

      const res = await POST('/product/filter-catalogs', filterDTO)

      setListSearchProducts(res.data)
      setMeta(res.meta)
      setLoadingComp(false)
    } catch (error) {
      setLoadingComp(false)
      console.error('Erro ao filtrar produtos:', error)
    }
  }

  const hasActiveFilters =
    activeFilters.categories.length > 0 ||
    activeFilters.status !== '' ||
    activeFilters.groups.length > 0

  useEffect(() => {
    loadSellers()
    loadCategories()
    loadGroups()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const searchProduct = async (
    take: number = 200,
    page: number = 1,
    search: string = '',
    order: OrderType = {field: 'name', type: 'ASC'}
  ) => {
    try {
      if (!searchproduct.trim() && !search.trim()) {
        Swal.fire({
          icon: 'warning',
          title: 'Atenção',
          text: 'Informe o nome do produto, antes de pesquisa!',
        })
        return
      }

      let res
      if (!search.trim()) {
        setLoadingComp(true)
        const filterDTO = transformFiltersToDTO(activeFilters, searchproduct)

        res = await POST(`/product/filter-catalogs?order=ASC&page=${page}&take=${take}`, filterDTO)
      } else {
        setLoadingComp(true)
        if (listsearchproducts.length > 0) {
          const resFilter = listsearchproducts.filter((product: any) => {
            return product.name.toLowerCase().includes(search.toLowerCase())
          })

          res = {
            data: resFilter,
            meta: {
              hasNextPage: false,
              hasPreviousPage: false,
              itemCount: resFilter.length,
              page: 1,
              pageCount: 1,
              take: 200,
            },
          }
        } else {
          const filterDTO: ProductFilterRequestDTO = {
            isInventoryGreaterThan: 1,
          }
          res = await POST(
            `/product/filter-catalogs?order=ASC&page=${page}&take=${take}&search=${search}`,
            filterDTO
          )
        }
      }

      setListSearchProducts(res.data)
      setMeta(res.meta)
      setLoadingComp(false)
    } catch (e) {
      setLoadingComp(false)
      console.log(e)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Um erro ocorreu ao filtrar os produto, verifique os nome informado!',
      })
    }
  }

  const delList = (id: any) => {
    const newList = listProducts.filter((row) => row.id !== id)
    setListProducts(newList)
  }

  const create = async () => {
    try {
      if (
        !name ||
        !startDate ||
        !finalDate ||
        !finalTimeDate ||
        !startTimeDate ||
        (sellerCatalog && !sellerId)
      ) {
        Swal.fire({
          icon: 'error',
          title: 'Campos faltantes',
          text: 'Verifique se preencheu todos os campos!',
        })
        return
      }
      setLoading(true)
      let imageRes = {
        success: false,
        image: '',
      }
      const catalogItem = listProducts.map((row) => {
        return {
          productId: row.id,
          sellerId: row.sellerId,
          allowDiscount: sellerCatalog && row.allowDiscount,
          sellerCatalog: sellerCatalog,
          status: true,
        }
      })

      // Validação das datas
      const startDateTime = moment(`${startDate} ${startTimeDate}`, 'YYYY-MM-DD HH:mm:ss', true)
      const endDateTime = moment(`${finalDate} ${finalTimeDate}`, 'YYYY-MM-DD HH:mm:ss', true)

      if (!startDateTime.isValid() || !endDateTime.isValid()) {
        Swal.fire({
          icon: 'error',
          title: 'Data inválida',
          text: 'Verifique se as datas e horários estão corretos!',
        })
        setLoading(false)
        return
      }

      if (endDateTime.isSameOrBefore(startDateTime)) {
        Swal.fire({
          icon: 'error',
          title: 'Data final inválida',
          text: 'A data/hora final deve ser posterior à data/hora inicial!',
        })
        setLoading(false)
        return
      }

      const resCatalog = await POST('/catalog', {
        catalog: name,
        dateStart: moment(`${startDate} ${startTimeDate}`, 'YYYY-MM-DD HH:mm:ss')
          .utc()
          .toISOString(),
        dateEnd: moment(`${finalDate} ${finalTimeDate}`, 'YYYY-MM-DD HH:mm:ss').utc().toISOString(),
        order: order,
        sellerCatalog,
        sellerId,
        linkCatalog,
        isExclusive: isExclusive,
        catalogItem: catalogItem,
        imgCatalog: '',
      })
      if (image) {
        const formData = new FormData()
        formData.append('file', image)
        formData.append('nameImage', `catalog-${uuid()}.jpg`)
        imageRes = await POST('/upload-images/upload-one', formData)
        if (imageRes.success) {
          await PUT(`/catalog/${resCatalog.dados.id}`, {
            fotoCatalog: imageRes.image,
          })
        }
      }
      setLoading(false)

      if (resCatalog.success === true) {
        Swal.fire({
          icon: 'success',
          title: 'Catálogo cadastrado',
          text: 'Cadastro realizado com sucesso!',
        }).then(() => navigate(`/catalog`))
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Erro ao cadastrar o catálogo!',
        })
      }
    } catch (e) {
      setLoadingComp(false)
      console.log(e)
    }
  }

  async function loadSellers() {
    try {
      setLoading(true)
      const resSeller = await POST('/users/filter', {
        type: 'seller',
        status: true,
      })
      setLoading(false)

      if (!resSeller || !resSeller.success) {
        Swal.fire({
          icon: 'warning',
          title: 'Atenção',
          text: 'Não foi possivel carregar os vendedores!',
        })
        return
      }

      resSeller.data.unshift({name: 'Escolha um vendedor', id: 0, cpf: '0'})

      setSeller(
        resSeller.data
          .filter((seller: any) => seller.removed !== 1)
          .map((seller: any) => {
            return {
              select: seller.name,
              cpf: seller.cpf,
              value: seller.id,
            }
          })
      )
    } catch (error) {
      setLoading(false)
    }
  }

  function changeCatalogLink() {
    if (sellerCatalog) {
      const sellerFind = sellers.find((seller) => seller.value === sellerId)

      if (sellerFind) {
        setLinkCatalog(`?vendor=${window.btoa(sellerFind.cpf)}`)
      }
    }
  }

  useEffect(() => {
    loadSellers()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (sellerId) changeCatalogLink()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sellerId])

  const switchAllowDiscount = async (Id: number, status: boolean) => {
    try {
      const newProducts = listProducts.map((product) => {
        if (product.id === Id.toString()) {
          product.allowDiscount = !status
        }
        return product
      })
      setListProducts(newProducts)
    } catch (e) {
      console.log(e)
    }
  }

  // const switchSelectedToCatalog = async (Id: number, status: boolean) => {
  //   try {
  //     const newProducts = listsearchproducts.map((el) => {
  //       if (el.id.toString() === Id.toString()) {
  //         el.selected = !el.selected
  //       }

  //       return el
  //     })
  //     const qtrSelected = newProducts.filter((el) => el.selected).length
  //     setListProductsSelected(qtrSelected)
  //   } catch (e) {
  //     console.log(e)
  //   }
  // }

  // const switchSelectedInCatalog = async (Id: number, status: boolean) => {
  //   try {
  //     const newProducts = listProducts.map((el) => {
  //       if (el.id.toString() === Id.toString()) {
  //         el.selected = !el.selected
  //       }

  //       return el
  //     })
  //     setListProductsCatalogSelected(newProducts.filter((el) => el.selected).length)
  //   } catch (e) {
  //     console.log(e)
  //   }
  // }

  const addList = (id: any) => {
    const newList = [...listProducts] // Usar spread operator
    const alreadyExists = newList.some((product) => product.id === id)

    if (!alreadyExists) {
      const selected = listsearchproducts.find((product) => product.id === id)
      if (selected) {
        newList.push({
          ...selected,
          selected: false, // Adiciona o campo selected com valor false
        })
        setListProducts(newList)
      }
    }
  }

  function addMultipleList() {
    const selectedProducts = listsearchproducts.filter((el) => el.selected)
    console.log('Adicionar múltiplos produtos:', selectedProducts)

    // Criar uma nova lista com todos os produtos de uma vez
    const currentProducts = [...listProducts]
    const productsToAdd = selectedProducts.filter(
      (product) => !currentProducts.some((existing) => existing.id === product.id)
    )

    if (productsToAdd.length > 0) {
      setListProducts([
        ...currentProducts,
        ...productsToAdd.map((product) => ({
          ...product,
          selected: false,
        })),
      ])
    }

    // Opcional: Limpar seleções após adicionar
    const updatedSearchProducts = listsearchproducts.map((product) => ({
      ...product,
      selected: false,
    }))
    setListSearchProducts(updatedSearchProducts)
    setListProductsSelected(0)
  }

  function removeMultipleList() {
    const selectedProducts = listProducts.filter((el) => el.selected)

    // Criar uma nova lista removendo os produtos selecionados
    const currentProducts = [...listProducts]
    const productsToKeep = currentProducts.filter(
      (product) => !selectedProducts.some((selected) => selected.id === product.id)
    )

    if (selectedProducts.length > 0) {
      setListProducts(productsToKeep)

      // Opcional: Atualizar contador de selecionados
      setListProductsCatalogSelected(0)

      // Opcional: Mostrar confirmação
      console.log(`${selectedProducts.length} produto(s) removido(s) do catálogo`)
    }
  }

  function activeMultipleDiscount() {
    const selectedProducts = listProducts.filter((el) => el.selected)

    if (selectedProducts.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Atenção',
        text: 'Nenhum produto selecionado para ativar desconto!',
      })
      return
    }

    const updatedProducts = listProducts.map((product) => {
      if (selectedProducts.some((el) => el.id === product.id)) {
        product.allowDiscount = true
        product.selected = false
      }
      return product
    })
    setListProductsCatalogSelected(0)
    setListProducts(updatedProducts)
  }

  const desactiveMultipleDiscount = () => {
    const selectedProducts = listProducts.filter((el) => el.selected)

    if (selectedProducts.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Atenção',
        text: 'Nenhum produto selecionado para remover desconto!',
      })
      return
    }

    const updatedProducts = listProducts.map((product) => {
      if (selectedProducts.some((el) => el.id === product.id)) {
        product.allowDiscount = false
        product.selected = false
      }
      return product
    })
    setListProductsCatalogSelected(0)
    setListProducts(updatedProducts)
  }

  function onSelectAllProductsInCatalog(all: boolean, id: number, value: boolean) {
    try {
      const newListProducts = listProducts.map((row: any) => {
        if (all) {
          row.selected = value
        }
        if (!all && row.id === id) {
          row.selected = !row.selected
        }
        return row
      })

      setListProductsCatalogSelected(newListProducts.filter((item) => item.selected).length)
    } catch (error) {
      console.log(error)
      return
    }
  }

  function onSelectAllProductsFiltered(all: boolean, id: number, value: boolean) {
    try {
      const newListProducts = listsearchproducts.map((row: any) => {
        if (all) {
          row.selected = value
        }
        if (!all && row.id === id) {
          row.selected = !row.selected
        }
        return row
      })

      setListProductsSelected(newListProducts.filter((item) => item.selected).length)
    } catch (error) {
      console.log(error)
      return
    }
  }

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          {/* Seção 1: Informações Básicas do Catálogo */}
          <div className='col-12'>
            <div className='card card-xxl-stretch mb-5'>
              <div className='card-header py-5'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='card-label fw-bolder fs-3 mb-1'>
                    {i18n.t(`smart_order.create_catalog`)}
                  </span>
                  <BreadCrumbs />
                  <span className='text-muted mt-1 fw-bold fs-7'>
                    {i18n.t(
                      `general.fill_in_the_information_below_and_click_on_the_create_button_to_save_the_changes`
                    )}
                  </span>
                </h3>
              </div>
              <div className='card-body'>
                <div className='d-flex flex-row flex-wrap gap-10'>
                  <div>
                    <Input
                      inputAttr={{
                        type: 'image',
                      }}
                      label={i18n.t(`smart_order.catalog_image`)}
                      value={image}
                      change={(value: BaseSyntheticEvent) =>
                        setImage(value ? value.target.files[0] : null)
                      }
                    />
                  </div>
                  <div style={{flex: 1}}>
                    <div className='row'>
                      <div className='col-md-6'>
                        <Input
                          inputAttr={{
                            type: 'default',
                          }}
                          placeholder={i18n.t(`smart_order.name`)}
                          label={i18n.t(`smart_order.name`)}
                          value={name}
                          change={(value: string) => setName(value)}
                        />
                      </div>
                      <div className='col-md-2'>
                        <Input
                          inputAttr={{
                            type: 'number',
                          }}
                          placeholder={i18n.t(`smart_order.order`)}
                          label={i18n.t(`smart_order.order`)}
                          value={order}
                          change={(value: string) => setOrder(value)}
                        />
                      </div>
                      <div className='col-md-4'>{/* Espaço para manter o layout */}</div>
                    </div>
                    <div className='row'>
                      <div className='col-md-4'>
                        <Input
                          inputAttr={{type: 'date'}}
                          label={i18n.t(`smart_order.date_start`)}
                          value={startDate}
                          change={setStartDate}
                          maxLength={finalDate}
                        />
                      </div>
                      <div className='col-md-4'>
                        <Input
                          inputAttr={{type: 'time'}}
                          placeholder='hh:mm:ss'
                          label={i18n.t(`smart_order.initial_hour`)}
                          value={startTimeDate}
                          change={setStartTimeDate}
                        />
                      </div>
                      <div className='col-md-4'>{/* Espaço para manter o layout */}</div>
                    </div>
                    <div className='row'>
                      <div className='col-md-4'>
                        <Input
                          inputAttr={{type: 'date'}}
                          label={i18n.t(`smart_order.date_end`)}
                          value={finalDate}
                          change={setFinalDate}
                          minLength={startDate}
                        />
                      </div>
                      <div className='col-md-4'>
                        <Input
                          inputAttr={{type: 'time'}}
                          placeholder='hh:mm:ss'
                          label={i18n.t(`smart_order.final_hour`)}
                          value={finalTimeDate}
                          change={setFinalTimeDate}
                        />
                      </div>
                      <div className='col-md-4'>{/* Espaço para manter o layout */}</div>
                    </div>
                    <div className='row'>
                      <div className='col-12 mt-6'>
                        <Input
                          inputAttr={{type: 'checkbox'}}
                          label={'Catálogo Vendedor'}
                          value={sellerCatalog}
                          change={(value: boolean) => setSellerCatalog(value)}
                          checked={sellerCatalog}
                        />

                        {sellerCatalog && (
                          <div className='d-flex gap-4 align-items-center mt-3'>
                            <div style={{minWidth: '200px'}}>
                              <Input
                                inputAttr={{type: 'select'}}
                                label={'Selecione o Vendedor'}
                                value={sellerId}
                                options={sellers}
                                change={(value: string) => setSellerId(parseInt(value))}
                              />
                            </div>
                            {sellerId !== 0 && sellerId > 0 && (
                              <div
                                className='d-flex align-items-center'
                                style={{marginTop: '2rem'}}
                              >
                                <Input
                                  inputAttr={{type: 'checkbox'}}
                                  label={'Catálogo Exclusivo'}
                                  value={isExclusive}
                                  change={(value: boolean) => setIsExclusive(value)}
                                  checked={isExclusive}
                                />
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Seção 2: Gestão de Produtos */}
          <div className='same-height-container'>
            <ProductSearchCard
              // Props principais
              searchValue={searchproduct}
              onSearchChange={setSearchProduct}
              onSearch={() => searchProduct()}
              searchResults={listsearchproducts}
              loading={loadingComp}
              selectedCount={listProductsSelected}
              // Props de filtros
              hasActiveFilters={hasActiveFilters}
              activeFilters={activeFilters}
              onShowFilters={() => setShowFilters(true)}
              onClearFilters={handleClearFilters}
              // Props da tabela
              onSelectAll={onSelectAllProductsFiltered}
              onAddItem={addList}
              meta={meta}
              onTableDataChange={searchProduct}
              // Props de customização
              title='Seus Produtos'
              titleIcon='fas fa-search'
              searchPlaceholder={i18n.t(`smart_order.search_products`)}
              emptyMessage='Pesquise por produtos para adicionar ao catálogo'
              noResultsMessage='Nenhum produto encontrado'
              // Props opcionais
              showSelectedButton={true}
              onSelectedAction={addMultipleList}
              tableHeaders={[
                {key: 'Código', value: 'code', type: 'default'},
                {key: i18n.t(`smart_order.prod`), value: 'name', type: 'default'},
                {key: i18n.t(`general.actions`), value: 'acoes', type: '', noOrder: true},
              ]}
              tableOptions={[
                {
                  icon: 'fas fa-plus',
                  title: 'adicionar',
                  color: 'success',
                  action: (item) => addList(item.id),
                },
              ]}
              // Props de layout
              cardClassName='card mb-5 same-height-column'
              maxTableHeight='400px'
            />

            <CatalogProductsTable
              // Props principais
              products={listProducts}
              selectedCount={listProductsCatalogSelected}
              showSellerOptions={sellerCatalog}
              // Props de ações
              onSelectAll={onSelectAllProductsInCatalog}
              onRemoveProduct={delList}
              onToggleDiscount={switchAllowDiscount}
              // Props de ações em massa
              onAddMultipleDiscount={activeMultipleDiscount}
              onRemoveMultipleDiscount={desactiveMultipleDiscount}
              onRemoveMultipleProducts={removeMultipleList}
              // Props de customização
              title='Produtos no Catálogo'
              titleIcon='fas fa-clipboard'
              emptyMessage='Nenhum produto adicionado ao catálogo'
              emptySubMessage='Use a pesquisa ao lado para encontrar e adicionar produtos'
              tableColor='success'
              maxTableHeight='400px'
              // Headers customizados
              customHeaders={[
                {key: 'Código', value: 'code', type: 'default'},
                {key: i18n.t(`smart_order.prod`), value: 'name', type: 'default'},
                {
                  key: 'Permitir Desconto',
                  value: 'allowDiscount',
                  type: 'check',
                  action: (item: any) => switchAllowDiscount(item.id, item.allowDiscount),
                  show: sellerCatalog,
                },
                {key: i18n.t(`general.actions`), value: 'acoes', type: '', noOrder: true},
              ]}
              // Opções customizadas da tabela
              customOptions={[
                {
                  icon: 'fas fa-trash',
                  action: (item: any) => delList(item.id),
                  title: 'remover',
                  color: 'danger',
                },
              ]}
              // Opções do catálogo
              catalogOptions={[
                {
                  name: 'Permitir Desconto',
                  icon: 'bi-plus',
                  action: () => activeMultipleDiscount(),
                  show: sellerCatalog,
                },
                {
                  name: 'Remover Permissão de Desconto',
                  icon: 'bi-dash',
                  action: () => desactiveMultipleDiscount(),
                  show: sellerCatalog,
                },
                {
                  name: 'Remover Produto(s)',
                  icon: 'bi-trash',
                  action: () => removeMultipleList(),
                },
              ]}
              // Props de layout
              cardClassName='card same-height-column mb-5'
              showCatalogOptions={true}
            />
          </div>

          {/* Seção 3: Ações */}
          <div className='col-12'>
            <div className='card card-xxl-stretch'>
              <div className='card-body'>
                <div className='d-flex justify-content-between align-items-center'>
                  <Button
                    text={i18n.t(`buttons.back`)}
                    color='info'
                    size='small'
                    horizontalPadding={6}
                    btnAttr={{
                      type: 'button',
                    }}
                    click={() => navigate(-1)}
                    btnClass='fw-bolder'
                  />

                  <div className='d-flex gap-3'>
                    <Button
                      text={i18n.t(`buttons.save`)}
                      color='primary'
                      size='small'
                      horizontalPadding={6}
                      btnAttr={{
                        type: 'button',
                      }}
                      click={() => create()}
                      btnClass='fw-bolder'
                      disabled={
                        !name || !startDate || !finalDate || !finalTimeDate || !startTimeDate
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Filtros */}
      <ProductFilter
        isOpen={showFilters}
        activeFilters={activeFilters}
        setActiveFilters={setActiveFilters}
        onClose={() => setShowFilters(false)}
        onApplyFilters={handleApplyFilters}
        onClearFilters={handleClearFilters}
        categories={categories}
        groups={groups}
        loading={loadingComp}
      />
    </>
  )
}

const CriarCatalogos: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {title: i18n.t(`smart_order.catalogs`), path: 'catalog', isActive: true},
          {title: i18n.t(`buttons.create`), path: 'catalog/criar', isActive: true},
        ]}
      >
        {`${i18n.t(`buttons.create`)} ${i18n.t(`smart_order.catalogs`)}`}
      </PageTitle>
      <CriarCatalogosContent />
    </>
  )
}

export {CriarCatalogos}
